import { useContext, useEffect, useState, useRef } from "react";
import MapContext from "../Map/MapContext";
import OLTileLayer from "ol/layer/Tile";

const TileLayer = ({ source, zIndex = 0, selectedLayers }) => {
  const { map } = useContext(MapContext);
  const [tileLayer, setTileLayer] = useState();
  const didMount = useRef(false);

  useEffect(() => {
    if (!map) return;

    let tileLayer = new OLTileLayer({
      source,
      zIndex,
    });
    map.addLayer(tileLayer);
    tileLayer.setZIndex(zIndex);
    setTileLayer(tileLayer);
    return () => {
      if (map) {
        map.removeLayer(tileLayer);
      }
    };
  }, [map]);

  // SelectedLayers is used as dependency instead of source to avoid doing a deep comparison since source
  // is an object. If selectedLayers has changed source will have changed as well. If anyone can think of
  // a cleaner way to do this then feel free to make that change. Stringifying source does not do the trick. - OA (2023-04-17)
  useEffect(() => {
    if (didMount.current) {
      tileLayer?.setSource(source);
    } else {
      didMount.current = true;
    }
  }, [selectedLayers]);

  return null;
};

export default TileLayer;
